import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';

interface UseCombinedPlaylistReachProps {
  days?: number;
  endDate?: Date;
}

/**
 * Combined follower reach across all of the user's followed playlists, as a
 * daily series. Backed by playlists.combinedFollowersTimeSeries (one ClickHouse
 * SUM-by-date query).
 */
export const useCombinedPlaylistReach = ({ days = 14, endDate }: UseCombinedPlaylistReachProps) => {
  const trpcMusicAPI = useTRPCAPI();

  return useTRPCQuery(trpcMusicAPI.playlists.combinedFollowersTimeSeries.queryOptions({ days, endDate }));
};
